export const HEADER = [
	['core/paragraph', {
		placeholder: 'Accordion title'
	}]
]
